const indianize = require('./indianize').default

export default function(age, goal) {
  switch(goal.category) {
    case "retirement":
      return `I will retire at ${goal.spendStartAge} and spend ₹${(goal.currentSpend/100000).toFixed(2)} lakh every month at today’s price levels`
    
    case "education":
      return `I will fund my child's ${goal.spendStopAge - goal.spendStartAge} year college education starting ${goal.spendStartAge - age} years from now`
    
    case "holidays":
      return `I will take a vacation every year from the age of ${goal.spendStartAge} to ${goal.spendStopAge}`
    
    case "purchase":
      return `In ${goal.spendStartAge - age} years, I will buy something that costs ₹${(goal.currentSpend/100000).toFixed(2)} lakh at today's price levels`

    case "freedom":
      const lookup = {
        '00': `I will invest ₹${indianize(goal.currentSpend)} every month`,
        '01': `I will invest ₹${indianize(goal.currentSpend)} every month`,
        '10': `I will invest ₹${indianize(goal.startingAllocation)}`,
        '11': `I will invest ₹${indianize(goal.startingAllocation)} and another ₹${indianize(goal.currentSpend)} every month`
      }
      const check = (goal.startingAllocation > 0 ? '1' : '0') + (goal.currentSpend > 0 ? '1' : '0')
      return `${lookup[check]} for things I haven't yet figured out I'd need money for.`

    default:
      return ""
  }
}


// WEBPACK FOOTER //
// ./src/utils/summarize.js